import DataVerification from "./DataVerification";

export default DataVerification;
